import moment from "moment-timezone";
import { Timezones } from "@obby/constants";

export function UnixTimestamp__UTCDate(unixTimestamp: number) {
  const date = moment(unixTimestamp * 1000);
  return date.isValid() ? date.toISOString() : null;
}
